// extracted by mini-css-extract-plugin
export default {"glassContainer":"LoginForm_glassContainer__3bN4y","relative-container":"LoginForm_relative-container__gwtWU"};